import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

// capital-mui-theme v37 gray50 token. Token not available in v36
const muiV37Gray50 = '#F8F8F8';

export const styles = createTypedSxStyles({
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: '1380px'
    }
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  dialogContent: {
    padding: 0,
    minHeight: '400px',
    height: '600px',
    display: 'flex'
  },
  dialogActions: {
    padding: '24px',
    backgroundColor: muiV37Gray50,
    justifyContent: 'flex-end'
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: '300px',
    maxWidth: '300px',
    borderRight: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`,
    padding: '24px'
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: capitalDesignTokens.foundations.colors.white,
    padding: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto'
  },
  textField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    }
  },
  deleteButton: {
    width: 'fit-content',
    padding: '5px 10px'
  },
  deleteMessage: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  actionButton: {
    minWidth: '80px'
  },
  loadingIcon: {
    marginLeft: '8px'
  }
});
